import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';
import { DraggableModule } from '../directives/draggable.module';

// select dropdown menu
import { NgSelectModule } from '@ng-select/ng-select';

// number formatter

// ngx-bootstrap  module
import { AlertModule } from 'ngx-bootstrap/alert';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ModalModule } from 'ngx-bootstrap/modal';

// Translating module
import { TranslateModule } from '@ngx-translate/core';
import { HttpClientModule } from '@angular/common/http';


import { HomeComponent } from '../home';
import { LandingComponent } from '../landing/landing.component';
import { NgxBootstrapConfirmComponent } from './ngx-bootstrap-confirm/ngx-bootstrap-confirm.component';
import { NgxBootstrapConfirmService } from './ngx-bootstrap-confirm/ngx-bootstrap-confirm.service';
import { TextMaskModule } from '@clearing-hub/angular-common';


const routes: Routes = [
  { path: '', component: LandingComponent },
  { path: 'login', component: LandingComponent },
  { path: 'home', component: HomeComponent },
];

@NgModule({

  imports: [
    ButtonsModule.forRoot(),
    ModalModule.forRoot(),
    TooltipModule.forRoot(),
    AlertModule.forRoot(),
    BsDropdownModule.forRoot(),
    TooltipModule.forRoot(),
    CollapseModule.forRoot(),
    // RouterModule.forRoot(routes, { useHash: true }),
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    DraggableModule,
    RouterModule
  ],
  declarations: [
    NgxBootstrapConfirmComponent
  ],

  providers: [
    NgxBootstrapConfirmService
  ],

  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA],

  exports: [
    AlertModule,
    BsDropdownModule,
    ButtonsModule,
    CollapseModule,
    FormsModule,
    ModalModule,
    NgSelectModule,
    ReactiveFormsModule,
    RouterModule,
    TextMaskModule,
    TooltipModule,
    TranslateModule,
    DraggableModule,
    NgxBootstrapConfirmComponent
  ]
})

export class SharedModule {
  constructor() { }
}


